import React, { useEffect, useState, useCallback } from 'react';
import './signup.css';
import { FaUser } from 'react-icons/fa';
import { useAuthContext } from '../../hooks/UseAuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../api';

const INITIAL_DATA = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  status: '',
};

function Signup() {
  const [data, setData] = useState(INITIAL_DATA);
  const [disabled, setDisabled] = useState(true);
  const [btnState, setBtnState] = useState('Create Account');
  const { dispatch } = useAuthContext();
  const navigate = useNavigate();

  // Validate form completeness
  useEffect(() => {
    const { firstName, lastName, email, password, status } = data;
    setDisabled(!(firstName && lastName && email && password && status));
  }, [data]);

  const handleChange = useCallback((field) => (e) => {
    setData(prev => ({ ...prev, [field]: e.target.value }));
  }, []);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    setBtnState('Creating account…');

    api.post('/register', data, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(() => {
        setData(INITIAL_DATA);
        toast.success('Account created successfully!');
        setBtnState('Create Account');
      })
      .catch(error => {
        setBtnState('Create Account');
        toast.error(error.response?.data?.error || error.response?.data?.msg || 'Something went wrong.');
      });
  }, [data]);

  return (
    <div className="signup">
      <div className="signup-form">
        <form onSubmit={handleSubmit}>

          {/* Header */}
          <div className="form-head">
            <span><FaUser /></span>
            <h3>Create your account</h3>
            <p>Fill in your details to get started with Alchemy Mix</p>
          </div>

          {/* First Name */}
          <div className="form-input">
            <label htmlFor="firstName">First Name</label>
            <input
              id="firstName"
              type="text"
              value={data.firstName}
              onChange={handleChange('firstName')}
              placeholder="First name"
              required
              autoComplete="given-name"
            />
          </div>

          {/* Last Name */}
          <div className="form-input">
            <label htmlFor="lastName">Last Name</label>
            <input
              id="lastName"
              type="text"
              value={data.lastName}
              onChange={handleChange('lastName')}
              placeholder="Last name"
              required
              autoComplete="family-name"
            />
          </div>

          {/* Email */}
          <div className="form-input">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={data.email}
              onChange={handleChange('email')}
              placeholder="your@email.com"
              required
              autoComplete="email"
            />
          </div>

          {/* Password */}
          <div className="form-input">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={data.password}
              onChange={handleChange('password')}
              placeholder="Minimum 8 characters"
              required
              autoComplete="new-password"
            />
          </div>

          {/* User Status */}
          <div className="form-input">
            <label htmlFor="status">User Status</label>
            <select
              id="status"
              value={data.status}
              onChange={handleChange('status')}
              required
            >
              <option value="">Select a role</option>
              <option value="user">User</option>
              <option value="admin">Administrator</option>
            </select>
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={disabled}
            className={disabled ? 'disabled' : 'enable'}
          >
            {btnState}
          </button>

        </form>
      </div>
    </div>
  );
}

export default Signup;